var _Path, _Path2, _Path3, _Path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgPlayListAdd = function SvgPlayListAdd(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M2 5H14V7H2V5Z",
    fill: "currentColor"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M2 9H14V11H2V9Z",
    fill: "currentColor"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "M10 13H2V15H10V13Z",
    fill: "currentColor"
  })), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    d: "M16 9H18V13H22V15H18V19H16V15H12V13H16V9Z",
    fill: "currentColor"
  })));
};
export default SvgPlayListAdd;